/* eslint-env es2020 */ // BigInt: eslintConfig do projeto so declara globals ate es6
export const DEFAULT_DID_RANGE_MAX = 1000;

const NUMERIC_RE = /^\d+$/;

export const expandDidRange = ({ start, end, limit } = {}) => {
  const s = typeof start === 'string' ? start.trim() : '';
  const e = typeof end === 'string' ? end.trim() : '';
  const max = Number.isFinite(limit) && limit > 0 ? limit : DEFAULT_DID_RANGE_MAX;

  if (!NUMERIC_RE.test(s) || !NUMERIC_RE.test(e)) {
    return { ok: false, code: 'NOT_NUMERIC', message: 'DDR inicial e final devem conter apenas dígitos' };
  }

  if (s.length !== e.length) {
    return { ok: false, code: 'LENGTH_MISMATCH', message: 'DDR inicial e final devem ter o mesmo tamanho' };
  }

  const len = s.length;
  const startNum = BigInt(s);
  const endNum = BigInt(e);

  if (endNum < startNum) {
    return { ok: false, code: 'ORDER', message: 'DDR final deve ser maior ou igual ao DDR inicial' };
  }

  const countBig = endNum - startNum + 1n;
  if (countBig > BigInt(max)) {
    return { ok: false, code: 'LIMIT', message: `Faixa excede o limite de ${max} números por operação` };
  }

  const count = Number(countBig);
  const prefixLen = Math.max(len - String(count).length, 0);
  const prefix = prefixLen > 0 ? s.slice(0, prefixLen) : '';

  if (prefixLen > 0 && s.slice(0, prefixLen) !== e.slice(0, prefixLen)) {
    return { ok: false, code: 'PREFIX', message: 'DDR inicial e final devem compartilhar o mesmo prefixo' };
  }

  const masks = [];
  for (let n = startNum; n <= endNum; n += 1n) {
    masks.push(n.toString().padStart(len, '0'));
  }

  return { ok: true, masks, count, prefix };
};

const didRange = { expandDidRange, DEFAULT_DID_RANGE_MAX };
export default didRange;
